import { connect } from 'react-redux'
import { compose, lifecycle } from 'recompose'
import { loadShoppingData } from 'actions/shoppingData'

export default compose(
  connect(null, { loadShoppingData }),
  lifecycle({
    componentDidMount() {
      this.props.loadShoppingData()
    }
  })
)

